import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M15.21 1.05005C15.21 1.05005 3.97996 11.3401 5.95996 33.5801C7.64996 52.5201 2.92993 56.0901 2.92993 56.0901C2.92993 56.0901 7.32992 58.0701 10.4199 55.8701C10.4199 55.8701 9.53991 60.7101 14.1599 64.6801C17.6099 67.6301 19.5 70.46 18.84 73.54C18.84 73.54 25.61 70.4001 25.39 65.5601C25.39 65.5601 26.27 76.8401 37.83 78.5001C49.39 80.1501 60.6199 65.5601 60.6199 65.5601C60.6199 65.5601 64.3599 68.2001 63.9199 75.2501C63.9199 75.2501 72.9999 71.56 71.4099 61.6C71.4099 61.6 76.91 63.5801 78.46 58.9601C78.46 58.9601 75.16 58.85 76.64 51.91C77.87 46.17 83.4099 29.4501 75.3199 7.65009L15.21 1.05005Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
